export default "__VITE_ASSET__PofzsRqp__"